<template>
  <!-- mobile fix menu start -->
  <FooterBarPage></FooterBarPage>
  <!-- mobile fix menu end -->

  <!-- theme btn start -->
  <div class="theme-btns">
    <button type="button" class="btntheme mode-change-button">
      <i id="themeIcon" class="ri-moon-line icon mode-icon"></i>
      <span class="text-value">Dark</span>
    </button>
    <button type="button" id="rtl-btn" class="btntheme rtlBtnEl">
      <i class="ri-repeat-line icon"></i>
      <span class="text-value">RTL</span>
    </button>
  </div>
  <!-- theme btn end -->

  <!-- tap to top start -->
  <button class="scroll scroll-to-top">
    <i class="ri-arrow-up-s-line arrow"></i>
  </button>
  <!-- tap to top end -->

  <!-- location offcanvas start -->
  <div
    class="modal fade location-modal"
    id="location"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <h5 class="fw-semibold">Select a Location</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div class="search-section">
            <form class="form_search" role="form">
              <input
                type="search"
                placeholder="Search Location"
                class="nav-search nav-search-field"
              />
            </form>
          </div>
          <a href="#!" class="current-location">
            <div class="current-address">
              <i class="ri-focus-3-line focus"></i>
              <div>
                <h5>Use current-location</h5>
                <h6>Wellington St., Ottawa, Ontario, Canada</h6>
              </div>
            </div>
            <i class="ri-arrow-right-s-line arrow"></i>
          </a>
          <h5 class="mt-sm-3 mt-2 fw-medium recent-title dark-text">
            Recent Location
          </h5>
          <a href="#!" class="recent-location">
            <div class="recant-address">
              <i class="ri-map-pin-line theme-color"></i>
              <div>
                <h5>Bayshore</h5>
                <h6>kingston St., Ottawa, Ontario, Canada</h6>
              </div>
            </div>
          </a>
        </div>
        <div class="modal-footer">
          <a href="#" class="btn gray-btn" data-bs-dismiss="modal">Close</a>
          <a href="#" class="btn theme-btn mt-0" data-bs-dismiss="modal"
            >Save</a
          >
        </div>
      </div>
    </div>
  </div>

  <!-- location offcanvas end -->
</template>

<script setup>
import FooterBarPage from "../layout/FooterBarPage.vue";
</script>

<style>
.mobile-menu .menu-box.active {
  color: #f2a93e;
  font-weight: bold;
}
</style>
